// extracted by css-extract-rspack-plugin
export default {"triggerWrapper":"trigger-wrapper--ZdS_MnGVH8v3y7Yh"};